<template>
  <el-card >
    <!-- 查询表单 -->
    <el-form :inline="true" :model="searchFactor" class="search-form">
      <el-form-item label="角色:" >
        <el-input v-model="searchFactor.roleName"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleCreateRole">创建</el-button>
      </el-form-item>
    </el-form>
    <!-- 角色表格 -->
    <el-table
      :data="tableData"
      :stripe ="true"
      :border = "true"
      height="calc(100vh - 200px)"
      max-height="calc(100vh - 200px)"
      :highlight-current-row ="true"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 90%">
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="roleName"
        label="角色名称"
        min-width="50px">
      </el-table-column>
      <el-table-column
        prop="createUser"
        label="创建者"
        width="120">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="50px">
      </el-table-column>
      <el-table-column
        prop="updateUser"
        width="200"
        label="更新者">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        width="280"
        label="更新时间">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注" >
      </el-table-column>
      <el-table-column label="操作" min-width="120px" width="240">
        <template slot-scope="scope" >
          <el-dropdown split-button type="primary" @command="handleCommand">
            管理
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided :command = '{event:"delete", index:scope.$index,data:scope.row}'><i class="el-icon-delete-solid" style="color:rgb(246, 102, 18)" ></i> <span>删除角色</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"signPermission",index:scope.$index, data:scope.row}'> <i class="el-icon-share" style="color:rgb(39, 193, 231)" ></i> <span>分配权限</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"signMenu",index:scope.$index, data:scope.row}'><i class="el-icon-notebook-2" style="color:rgb(41, 10, 239)" ></i> <span>分配菜单</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"edit",index:scope.$index, data:scope.row}'><i class="el-icon-document" style="color:rgb(40, 238, 10)" ></i> <span>修改角色</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <el-pagination
        background
        layout="total,prev, pager, next"
        :current-page.sync="pager.currentPage"
        style="margin:10px"
        @current-change="handleCurrentChange"
        :page-size="pager.pageSize"
        :total="pager.totalCount"
        >
    </el-pagination>
    <!-- 修改权限弹框 -->
    <el-dialog :close-on-click-modal="false"  :visible.sync="dialogVisual.editRoleDialogVisible" v-on:close ="clearEditRoleInfoForm" >
      <div slot="title" class="dialog-footer">
          <span> 角色[{{ editRoleForm.roleName }}] 信息变更 </span>
      </div>
      <el-form :model="editRoleForm" label-width="20%"> 
        <el-form-item label="角色名称:"  style="width: 80%">
          <el-input v-model="editRoleForm.roleName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注:" style="width: 80%">
          <el-input type="textarea" v-model="editRoleForm.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="ensureChange">确定变更</el-button>
      </div>
    </el-dialog>
    <!-- 创建角色弹框 -->
    <el-dialog :close-on-click-modal="false"  :visible.sync="dialogVisual.createRoleDialogVisible" v-on:close ="clearCreateRoleInfoForm" >
      <div slot="title" class="dialog-footer">
          <span> 创建角色信息 </span>
      </div>
      <el-form :model="createRoleForm" label-width="20%"> 
        <el-form-item label="角色名称:" style="width: 80%" >
            <el-input v-model="createRoleForm.roleName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注:" style="width: 80%">
            <el-input type="textarea" v-model="createRoleForm.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureCreate">创建角色</el-button>
      </div>
    </el-dialog>
    <!-- 分配权限弹框 -->
    <el-dialog :close-on-click-modal="false"  :visible.sync="dialogVisual.signPermissionDialogVisible" v-on:close ="clearSingPermissionInfoFrom" >
      <div slot="title" class="dialog-footer">
          <span> 给角色{{signPermissionInfoForm.roleInfo.roleName}}分配权限信息 </span>
      </div>
      <el-table
        ref="multipleTable"
        :data="signPermissionInfoForm.permissionList"
        :stripe ="true"
        :border = "true"
        :highlight-current-row ="false"
        :max-height="300"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        @selection-change="handleSelectionChange" >
        <el-table-column
          type="selection"
          width="100" >
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          :index="indexMethod">
        </el-table-column>
        <el-table-column
          prop="permissionName"
          label="权限名称"
          width="200">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注">
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureSignPermission()">确定分配</el-button>
      </div>
    </el-dialog>
    <!-- 分配菜单弹框 -->
    <el-dialog :close-on-click-modal="false"  :visible.sync="dialogVisual.signPcMenuDialogVisible" v-on:close ="clearPcMenuInfoFrom" >
      <div slot="title" class="dialog-footer">
        <span> 给角色{{signPcMenuInfoForm.roleInfo.roleName}}分配菜单 </span>
      </div>
      <div>
        <el-tree 
          :data="signPcMenuInfoForm.roleMenuTreeData"
          ref="tree"
          node-key="id"
          highlight-current
          :default-expand-all="true"
          :show-checkbox = "true"
          :check-strictly="true"
          :props="signPcMenuInfoForm.defaultProps">
        </el-tree>
      </div>
      <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="ensureSignPcMenu()">确定分配</el-button>
        </div>
    </el-dialog>
  </el-card>
</template>                     
<script>
import axios from  '@/api/axiosConfig'
import {stringIsNullOrEmpty} from  '@/api/utils'
import {PAGE_SIZE,MESSAGE_DURATION} from  '@/api/constant'
export default {
    name : 'pc_ctr_role',
    data() {
    return {
      tableHeight: 650,
      searchFactor: {
        roleName: ''     
      },
      tableData: [],
      pager:{
        currentPage:0,
        totalCount:0,
        pageSize : PAGE_SIZE
      },
      dialogVisual:{
        editRoleDialogVisible: false,
        createRoleDialogVisible: false,
        signPermissionDialogVisible:false,
        signPcMenuDialogVisible:false
      },
      editRoleForm: {
        roleName: '',
        remark: '',
        id :''
      },
      createRoleForm: {
        roleName: '',
        remark: ''
      },
      signPermissionInfoForm:{
          permissionList:[],
          multipleSelection :[],
          roleInfo:''
      },
      signPcMenuInfoForm:{
        menuList:[],
        roleInfo:'',
        roleMenuTreeData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        }
      }
    }
  },
  methods : {
    handleCommand(command){
    let index  = command.index
    let row = command.data
    let event = command.event
    switch(event){
      case 'delete' :
          this.handleDelete(index,row)
          break
      case 'edit' :
          this.handleEdit(index,row)
          break
      case 'signMenu':
          this.handleSignPcMenu(index,row)
          break
      case 'signPermission':
          this.handleSignPermissison(index,row)
          break
    }
  },
    indexMethod(index){
        return  index + 1
    },
    roleListLoad(pageNo){
      let url = "/bc/exa/role/rolePage"
      let { 
          roleName
      } = this.searchFactor 
      let dat0 = {
          pageSize: PAGE_SIZE,
          roleName,
          pageNo
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          if(dat.data.length !== 0){
            this.tableData = []
            dat.data.forEach(t=>this.tableData.push(t))
            if(pageNo == 1 ) {
                this.pager.currentPage = 1
            }
            this.pager.totalCount = dat.totalDataCount
          } else {
            this.$message({
              showClose: true,
              message: '未查询到角色信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch( (err) => {
          this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      });
    },
    clearEditRoleInfoForm(){
      this.editRoleForm.roleName = ''
      this.editRoleForm.remark = ''
      this.editRoleForm.id = ''
    },
    clearCreateRoleInfoForm(){
      this.createRoleForm.roleName = ''
      this.createRoleForm.remark = ''
    },
    clearSingPermissionInfoFrom(){
      this.signPermissionInfoForm.permissionList=[]
      this.signPermissionInfoForm.multipleSelection=[]
      this.signPermissionInfoForm.roleInfo=''
    },
    clearPcMenuInfoFrom(){
      this.signPcMenuInfoForm.roleMenuTreeData = []
      this.signPcMenuInfoForm.menuList = []
      this.$refs.tree.setCheckedKeys([]);
      this.signPcMenuInfoForm.roleInfo = ''
    },
    onSearch(){
      this.roleListLoad(1)
    },
    handleEdit(index, row){
      this.dialogVisual.editRoleDialogVisible = true
      this.editRoleForm.roleName = row.roleName
      this.editRoleForm.remark = row.remark
      this.editRoleForm.id = row.id
    },
    handleCreateRole(){
      this.dialogVisual.createRoleDialogVisible = true
    },
    ensureChange(){
      this.$confirm('即将更新角色['+this.editRoleForm.roleName+']信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doChangeRoleInfo()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消更新！'
        });
      })
    },
    doChangeRoleInfo(){
      let url = "/bc/exa/role/roleEdit"
      let s = JSON.stringify(this.editRoleForm)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.dialogVisual.editRoleDialogVisible= false;
          this.clearEditRoleInfoForm();
          this.$message({
            showClose: true,
            message: '更新成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.roleListLoad(1);
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    ensureCreate(){
      try{ 
        stringIsNullOrEmpty(this.createRoleForm.roleName,'请输角色名称!');
        stringIsNullOrEmpty(this.createRoleForm.remark,'请输角色备注!');
      }catch (e){
        this.$message({
              showClose: true,
              message: e,
              type: 'error',
              duration: MESSAGE_DURATION
        }) 
        return
      }
      this.doCreateRoleInfo();
    },
    doCreateRoleInfo(){
      let url = "/bc/exa/role/roleCreate"
      let s = JSON.stringify(this.createRoleForm)  
      axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.dialogVisual.createRoleDialogVisible= false
            this.clearCreateRoleInfoForm()
            this.$message({
              showClose: true,
              message: '创建成功',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            this.roleListLoad(1);
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err) => {
          this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            }) 
      })
    }, 
    handleCurrentChange(val){
      this.permissionListLoad(val);
    },
    handleDelete(index, row){
      this.$confirm('即将删除角色['+row.roleName+']信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doDeleteRole(row)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除！'
        });
      })
    },
    doDeleteRole(row){
      let datBat = [{id: row.id}]
      let url = "/bc/exa/role/roleDelete"
      let s = JSON.stringify(datBat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '删除成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.roleListLoad(1);
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    handleSignPermissison(index, row){
      this.dialogVisual.signPermissionDialogVisible = true
      this.signPermissionInfoForm.roleInfo = row
      let url = "/bc/exa/role/getRolePermission"
      let data = {id : row.id}
      let s = JSON.stringify(data)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          let resData = response.data.data
          if(resData.length !== 0){
            resData.forEach(t=> this.signPermissionInfoForm.permissionList.push(t)) 
            this.signPermissionInfoForm.permissionList.forEach(t=>{
              if(t.LAY_CHECKED){
                this.$refs.multipleTable.toggleRowSelection(t, true)
              }
            })
          }else{
              this.$message({
              showClose: true,
              message: '未获取到数据!',
              type: 'warn',
              duration: MESSAGE_DURATION
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    handleSelectionChange(val){
      this.signPermissionInfoForm.multipleSelection = val;
    },
    handleSelectionMenuChange(val){
      this.signPcMenuInfoFrom.multipleSelection = val;
    },
    handleSignPcMenu(index,row){
      this.dialogVisual.signPcMenuDialogVisible = true
      this.signPcMenuInfoForm.roleInfo = row
      let url = "/bc/exa/role/getRoleMenu"
      let data = {id : row.id}
      let s = JSON.stringify(data)
      axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            let resData = response.data.data
            if(resData.length !== 0){
              let rt = ''
              let levelOneList = []
              let levelTwoList = []
              let checkedList = []
              resData.forEach(t=>{
                if(t.level <= 2){
                  if(t.checked){
                    checkedList.push(t.id)
                  }
                }
                if(t.level == 0 ){
                  rt = { 
                    id : t.id,
                    label : t.menuName,
                    children:[]
                  }
                }else if ( t.level == 1){
                  levelOneList.push(t)
                }else if(t.level == 2){
                  levelTwoList.push(t)
                }
              }) 
              if(levelOneList.length !== 0){
                levelOneList.forEach(t=>{
                  let datOne = { 
                    id:t.id,
                    label: t.menuName,
                    children:[]
                  }
                  rt.children.push(datOne)
                  levelTwoList.forEach(p=>{
                    let datTwo = { 
                      id:p.id,
                      label: p.menuName
                    }
                    if(p.parentId == t.id){
                      datOne.children.push(datTwo)
                    }
                  })
                })
              }
              this.signPcMenuInfoForm.roleMenuTreeData.push(rt)
              if(checkedList.length !== 0){
                setTimeout(()=>{
                  this.$refs.tree.setCheckedKeys(checkedList)
                },200)
              }
            }else{
                this.$message({
                showClose: true,
                message: '未获取到数据!',
                type: 'warn',
                duration: MESSAGE_DURATION
              })
            }
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err)=>{
          this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
          }) 
      })
    },
    ensureSignPermission(){
      let list = this.signPermissionInfoForm.multipleSelection
      let roleInfo = this.signPermissionInfoForm.roleInfo
      if(list == '' || list.length == 0){
        this.$confirm('即将清空角色['+roleInfo.roleName+']的权限', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doSignPermission(list)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消删除！'
          });
        })
      } else{
        this.doSignPermission(list)
      } 
    },
    doSignPermission(list){
      let s = JSON.stringify(list)  
      let roleInfo = this.signPermissionInfoForm.roleInfo
      let url = "/bc/exa/role/assignPermission/" + roleInfo.id
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '操作成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    ensureSignPcMenu(){
      let list =  this.$refs.tree.getCheckedNodes()
      let roleInfo = this.signPcMenuInfoForm.roleInfo
      if (list == null || list.length == 0) {
          this.$confirm('您确定要清空[' + roleInfo.roleName + ']的菜单吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doAssignMenu(list)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消分配!'
          })
        })
      } else {
        this.doAssignMenu(list)
      }
    },
    doAssignMenu(list){
      let roleInfo = this.signPcMenuInfoForm.roleInfo
      let url = "/bc/exa/role/assignMenu/" + roleInfo.id
      let s = JSON.stringify(list)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '操作成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    }
},
created () {
    this.roleListLoad(1)
  }
}
</script>

<style lang="less" scoped>
.el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}

.text {
  font-size: 14px;
  color: #000;
}
</style>
    


// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_role.vue